import { isNil } from './func';

export function isTargetDescendant(event: Event, parent?: HTMLElement | null) {
    return !isNil(parent) && !isNil(event.target) && isDescendant(event.target as HTMLElement, parent);
}

export function isDescendant(element: Element, parent: Element) {
    let node = element as Node | null | undefined;
    while (!isNil(node)) {
        if (node === parent) {
            return true;
        }
        node = node.parentNode;
    }

    return false;
}

export function addEventListenerOnTransitionEnded(
    element: HTMLElement | undefined | null,
    fn: EventListenerOrEventListenerObject
) {
    if (!element) {
        return false;
    }

    element.addEventListener('transitionend', fn);
    return true;
}

export function removeEventListenerOnTransitionEnded(
    element: HTMLElement | undefined | null,
    fn: EventListenerOrEventListenerObject
) {
    if (!element) {
        return false;
    }

    element.removeEventListener('transitionend', fn);
    return true;
}
